import React from 'react'
import cx from 'classnames'
import { TItem } from '../../types'

const ImageLink: React.FC<{
  item: TItem
  index: number
  type: 'medium' | 'large'
  as?: React.ElementType
}> = (props) => {
  const Element = props.as || 'li'
  return (
    <Element
      className={cx('sm:h-32 md:h-40', {
        'h-32': props.type === 'medium',
        'h-40': props.type === 'large',
        'ml-16': props.index > 0,
      })}
    >
      <a href={`${props.item.url}`}>
        <img src={props.item.image} alt={props.item.alt || props.item.label} className="h-full" />
      </a>
    </Element>
  )
}

export { ImageLink as default }
